export default function filterTree(node, test) {
  let filteredChildren = node.children
    .map(child => filterTree(child, test))
    .filter(child => child !== null);

  return test(node)
    ? { ...node, isExpanded: true, children: filteredChildren }
    : filteredChildren.length > 0
      ? { ...node, isExpanded: true, children: filteredChildren }
      : null;
}
